module.exports = __webpack_public_path__ + "static/media/service-mob.faf14d0e.svg";